import { Icon } from "@iconify/react";
import React from "react";

/**
 * Muestra un icono de carga giratorio.
 * 
 * @param {{size:number, style:Object, className:string}} props - Props del componente.
 * @param {number} [props.size=30] - Tama o del icono. Por defecto es 30.
 * @param {Object} [props.style] - Estilos adicionales para el componente.
 * @param {string} [props.className] - Clases CSS adicionales para el componente.
 * @returns {JSX.Element} Componente que renderiza el icono de carga.
 */
export const LoadingSpinner = ({size=30, style, className}) => {
	return (
		
			<Icon icon="fa:spinner" width={size} className={`${className} spinner-rotation`} style={{...style}} />
		
	);
};
